import { Box, Button, FormikField, Text } from '@betterment/samba-react';
import { FormikValidateAfterSubmit } from '@betterment/shared-components';
import { Form } from 'formik';
import * as Yup from 'yup';

import { FormikFileUpload } from '../../../formik/FormikFileUpload';
import { UploadCsvValidationErrorType } from '../data';
import { UploadCsvValidationErrorBanner } from '../upload-csv-validation-error-banner/UploadCsvValidationErrorBanner';

const Schema = Yup.object().shape({
  csvFile: Yup.mixed().required('CSV file is required'),
});

type ResolveUploadFormValues = {
  csvFile: File | null;
};

const DEFAULT_INITIAL_VALUES: ResolveUploadFormValues = {
  csvFile: null,
};

export type ResolveUploadCsvFormProps = {
  onSubmit: (values: ResolveUploadFormValues) => Promise<void>;
  uploadCsvValidationError?: UploadCsvValidationErrorType | null;
};

export const ResolveUploadCsvForm = ({ onSubmit, uploadCsvValidationError }: ResolveUploadCsvFormProps) => {
  return (
    <Box
      css={{
        p: 'space.300',
        borderColor: 'border',
        borderStyle: 'solid',
        borderWidth: 'thin',
        borderRadius: 'medium',
      }}
    >
      <FormikValidateAfterSubmit<ResolveUploadFormValues>
        onSubmit={onSubmit}
        initialValues={DEFAULT_INITIAL_VALUES}
        validationSchema={Schema}
      >
        {({ isSubmitting }) => {
          return (
            <Form>
              <FormikField name="csvFile">
                <Box css={{ mb: 'space.300' }}>
                  <FormikField.Label>
                    <Text variant="text100">Upload CSV</Text>
                  </FormikField.Label>
                  <FormikFileUpload name="csvFile" acceptedFileTypes=".csv" />
                  <FormikField.Description>Maximum rows: 500</FormikField.Description>
                  <FormikField.ErrorMessage />
                </Box>
              </FormikField>

              {uploadCsvValidationError && (
                <Box css={{ mb: 'space.300' }}>
                  <UploadCsvValidationErrorBanner errorType={uploadCsvValidationError} />
                </Box>
              )}

              <Button type="submit" variant="solidPrimary" disabled={isSubmitting} css={{ width: '100%' }}>
                Continue
              </Button>
            </Form>
          );
        }}
      </FormikValidateAfterSubmit>
    </Box>
  );
};
